import React, { FC, memo } from "react";
import { ActionsGroup, DialogActions, FlatButton, Icon } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { DownloadButton } from "../styled";
import { ActionsProps } from "../types";

export const Actions: FC<ActionsProps> = memo(({ submit, cancel, loading }) => {
  const { t } = useTranslation("common");

  return (
    <DialogActions>
      <ActionsGroup>
        <DownloadButton onClick={submit} primary disabled={loading}>
          <Icon kind="download" />
          {t("actions.download")}
        </DownloadButton>
        <FlatButton onClick={cancel}>{t("actions.cancel")}</FlatButton>
      </ActionsGroup>
    </DialogActions>
  );
});
